export const getFileExtensionHandler = (fileName: string): string => {
  if (!fileName) {
    return '';
  }

  const dotIndex = fileName.lastIndexOf('.');
  const extension = fileName.slice(dotIndex);

  return extension;
}